import WEAWorldCup_Profile_Bible_Circle_DELUT from '../assets/graphics/png/WEAWorldCup_Profile_Bible_Circle/WEAWorldCup_Profile_Bible_Circle_DELUT.png';
import WEAWorldCup_Profile_Bible_Circle_Fr from '../assets/graphics/png/WEAWorldCup_Profile_Bible_Circle/WEAWorldCup_Profile_Bible_Circle_Fr.png';
import WEAWorldCup_Profile_Bible_Circle_Gk from '../assets/graphics/png/WEAWorldCup_Profile_Bible_Circle/WEAWorldCup_Profile_Bible_Circle_Gk.png';
import WEAWorldCup_Profile_Bible_Circle_He from '../assets/graphics/png/WEAWorldCup_Profile_Bible_Circle/WEAWorldCup_Profile_Bible_Circle_He.png';
// import WEAWorldCup_Profile_Bible_Circle_It from '../assets/graphics/png/WEAWorldCup_Profile_Bible_Circle/WEAWorldCup_Profile_Bible_Circle_It.png';
// import WEAWorldCup_Profile_Bible_Circle_Ja from '../assets/graphics/png/WEAWorldCup_Profile_Bible_Circle/WEAWorldCup_Profile_Bible_Circle_Ja.png';
// import WEAWorldCup_Profile_Bible_Circle_Ko from '../assets/graphics/png/WEAWorldCup_Profile_Bible_Circle/WEAWorldCup_Profile_Bible_Circle_Ko.png';
import WEAWorldCup_Profile_Bible_Circle_NIV from '../assets/graphics/png/WEAWorldCup_Profile_Bible_Circle/WEAWorldCup_Profile_Bible_Circle_NIV.png';
import WEAWorldCup_Profile_Bible_Circle_RCUV from '../assets/graphics/png/WEAWorldCup_Profile_Bible_Circle/WEAWorldCup_Profile_Bible_Circle_RCUV.png';
import WEAWorldCup_Profile_Bible_Circle_RCUVSS from '../assets/graphics/png/WEAWorldCup_Profile_Bible_Circle/WEAWorldCup_Profile_Bible_Circle_RCUVSS.png';
import WEAWorldCup_Profile_Bible_Circle_RVR from '../assets/graphics/png/WEAWorldCup_Profile_Bible_Circle/WEAWorldCup_Profile_Bible_Circle_RVR.png';
// import WEAWorldCup_Profile_Bible_Circle_Sv from '../assets/graphics/png/WEAWorldCup_Profile_Bible_Circle/WEAWorldCup_Profile_Bible_Circle_Sv.png';

export const bibleLanguages = [
  {
    code: 'NIV',
    name: 'English',
    imageSrc: WEAWorldCup_Profile_Bible_Circle_NIV,
  },
  {
    code: 'RVR1960',
    name: 'Spanish',
    imageSrc: WEAWorldCup_Profile_Bible_Circle_RVR,
  },
  {
    code: 'תנ״ך ומודרני',
    name: 'Hebrew',
    imageSrc: WEAWorldCup_Profile_Bible_Circle_He,
  },
  { code: 'FPB', name: 'Greek', imageSrc: WEAWorldCup_Profile_Bible_Circle_Gk },
  {
    code: 'LSG',
    name: 'French',
    imageSrc: WEAWorldCup_Profile_Bible_Circle_Fr,
  },
  {
    code: 'DELUT',
    name: 'German',
    imageSrc: WEAWorldCup_Profile_Bible_Circle_DELUT,
  },
  // {
  //   code: 'NR94',
  //   name: 'Italian',
  //   imageSrc: WEAWorldCup_Profile_Bible_Circle_It,
  // },
  // {
  //   code: 'B2000D',
  //   name: 'Swedish',
  //   imageSrc: WEAWorldCup_Profile_Bible_Circle_Sv,
  // },

  {
    code: 'RCUV',
    name: 'Traditional Chinese',
    imageSrc: WEAWorldCup_Profile_Bible_Circle_RCUV,
  },
  {
    code: 'RCUVSS',
    name: 'Simplified Chinese',
    imageSrc: WEAWorldCup_Profile_Bible_Circle_RCUVSS,
  },
  // {
  //   code: '聖書 口語訳',
  //   name: 'Japanese',
  //   imageSrc: WEAWorldCup_Profile_Bible_Circle_Ja,
  // },
  // {
  //   code: 'KRV',
  //   name: 'Korean',
  //   imageSrc: WEAWorldCup_Profile_Bible_Circle_Ko,
  // },
];
